import { fetcher } from "utils/ApiUtil";

export interface ICommunityGroup {
  no?: number;
  title?: string;
}

export async function getCategoryList() {
  return await fetcher("/api/community/getcategorylist_v2");
}

export async function getCommunityGroupList() {
  return await fetcher<{ result: ICommunityGroup[] }>(
    "/api/community/getGroupList"
  );
}
